module.exports = require('./src/jaxcore-virtualspin');